import { websiteUrl } from "../config/config";

export const SuperAdmins =
	websiteUrl === "https://events.konfhub.com"
		? ["hari@konfhub.com", "ganesh@konfhub.com", "rohit@konfhub.com", "srushith@konfhub.com"]
		: ["backend@konfhub.com", "qa@konfhub.com", "frontend@konfhub.com"];
